var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11883 4.39961H5.19961M9.74506 6.25415L14.1067 10.6158C14.2943 10.8033 14.3996 11.0577 14.3996 11.3229V13.3996C14.3996 13.9519 13.9519 14.3996 13.3996 14.3996H12.0723V12.6542H10.3269V10.9087L8.17701 8.88406C7.48618 9.42357 6.6168 9.74506 5.67234 9.74506C3.42303 9.74506 1.59961 7.92164 1.59961 5.67234C1.59961 3.42303 3.42303 1.59961 5.67234 1.59961C7.92164 1.59961 9.74506 3.42303 9.74506 5.67234V6.25415Z",
    stroke: "#46597A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassNew);
export default __webpack_public_path__ + "static/media/reset_pass_new.ad9779f0191bccdbb3ff1bae982a567d.svg";
export { ForwardRef as ReactComponent };